import React from 'react';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import ApiClient from '../../helpers/ApiClient';
import config from '../../config';
import Toolbar from '../../components/Toolbar';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, ImageUpload, FileUpload, Select, Checkbox} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ChangeBar from '../../components/ChangeBar';
import IconCheckbox from '../../components/Form/IconCheckbox';
import TableForm from '../../components/TableForm';
import ButtonToolbar from '../../components/ButtonToolbar';
import NavBar from '../../components/NavBar';

const ACTIVE_BY_PASS = 2;

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'user.fetch',
			save: 'user.save',
			remove: 'user.delete',
		};

		this.changeEvent = 'user.change';
		this.savePushState = '/user';

		this.messages = {
			remove: 'Opravdu si přejete uživatele odstranit?',
			notfound: 'Uživatel nenalezen!'
		};

		this.schema = {

			name: {
				class: TextInput,
				label: 'Jméno',
				rules: {
					presence: {message: 'Jméno je povinná položka!'}
				}
			},
			surname: {
				class: TextInput,
				label: 'Příjmení',
				rules: {
					presence: {message: 'Příjmení je povinná položka!'}
				}
			},
			email: {
				class: TextInput,
				label: 'E-mail',
				type: 'email',
				addonBefore: <span className="fa fa-envelope-o"></span>,
				rules: {
					presence: {message: 'Zadejte e-mail!'},
					email: {message: 'Zadejte platný e-mail!'},
					async: {
						promise: (value) => {
							return config.getApiClient.call('user.existsEmail', {email: value, id: this.props.id});
						},
						message: 'E-mail již používá jiný uživatel.'
					}
				}
			},
			phone: {
				class: TextInput,
				label: 'Telefon',
				addonBefore: <span className="fa fa-phone"></span>,
			},
			active: {
				class: IconCheckbox,
				label: 'Aktivní',
				value: true
			},
			/*role: {
				class: Select,
				label: 'Role',
				value: 1,
				clearable: false,
				options: DbInfo.Roles,
				visible: (form) => {
					return form.active;
				}
			},*/
			/*login: {
				class: TextInput,
				label: 'Přihlašovací jméno',
				visible: function(form) {
					return form.active
				},
				rules: {
					async: {
						promise: (value) => {
							return config.getApiClient.call('user.existsLogin', {login: value, id: this.props.id});
						},
						message: 'Login již používá jiný uživatel.'
					}
				}
			},*/
			activate: {
				class: RadioList,
				label: 'Způsob aktivace účtu',
				value: 1,
				options: [{id: 1, title: 'Poslat aktivační e-mail'}, {id: ACTIVE_BY_PASS, title: 'Zadat heslo'}],
				visible: (form) => {
					return !this.props.id && form.active
				}
			},
			password: {
				class: TextInput,
				type: 'password',
				label: 'Heslo',
				visible: (form) => {
					return form.active && (/*this.props.id || */form.activate == ACTIVE_BY_PASS)
				}
			},
			passwordConfirm: {
				class: TextInput,
				type: 'password',
				label: 'Heslo pro kontrolu',
				visible: (form) => {
					return form.active && (/*this.props.id ||*/ form.activate == ACTIVE_BY_PASS)
				},
				rules: {
					equality: {
						attribute: 'password',
						message: 'Hesla se musejí shodovat!'
					}
				}
			},
			image: {
				class: ImageUpload,
				galleryPicker: false,
				label: 'Foto'
			},
			notice: {
				class: TextArea,
				label: 'Poznámka',
				style: { height: '50px'}
			}
		};
		this.form = new FormManager(this.schema);

	}

	componentDidMount() {
		this.form.on('change', (key, value, values) => {
			if (key == 'name' || key == 'surname') {
				this.title = (values.get('name') ? values.get('name') : '') + ' ' +
					(values.get('surname') ? values.get('surname') : '');
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.name + ' ' + data.surname});
	}

	handleSendPassword() {
		const api = new ApiClient();
		api.call('user.resetPassword', {id: this.props.id}, {progress:true}).then((data) => {
			if (!data.error) {
				this.context.flashMessage({
					message: 'E-mail s instrukcemi byl odeslán.'
				});
			}
		});
	};

	onSave() {
		this.context.flashMessage({message: 'Uživatel byl uložen.'});
	}


	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				title: 'Odeslat zapomenuté heslo',
				icon: 'fa fa-envelope-o',
				visible: !isNew,
				bsStyle: 'default',
				onClick: () => this.handleSendPassword()
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				visible: !isNew,
				disabled: !canDelete,
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];


		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<NavBar buttons={toolbar} onClose={this.props.closeTab} title="Uživatel" />
					<Toolbar title="Uživatel">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<ChangeBar visible={this.state.showChangedBar} items={this.state.extChangedItems} onAcceptChanges={() => this.acceptChanges()} onClose={() => this.setState({showChangedBar: false})} />
					<div className="row">
						<div className="col-md-6">
							<TableForm>
								<FormRow name="location" labelWidth={150}/>
								<FormRow name="name" labelWidth={150}/>
								<FormRow name="surname" />
								<FormRow name="email" />
								<FormRow name="phone" />
								<FormRow name="active" />
								<FormRow name="activate" visible={this.schema.activate.visible} />
								<FormRow name="password" visible={this.schema.password.visible} />
								<FormRow name="passwordConfirm" visible={this.schema.passwordConfirm.visible} />
								<FormRow name="image" />
								<FormRow name="notice" />
								<FormRow className="buttons vp-desktop">
									{saveCloseButton}
								</FormRow>
							</TableForm>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/User/Form.js